module.exports = __webpack_public_path__ + "static/media/success_icon.4b55cc37.png";